
    <div class="ui-g customer-list">

<!--      <div class="ui-g-12 text-right">-->

<!--        <button pButton type="button" class="k-generic-btn" icon="fa fa-chevron-left"-->
<!--                iconPos="left" label="{{ 'common.back' | translate }}"-->
<!--                (click)="_onBack()"-->
<!--        ></button>-->


<!--      </div>-->
      <div class="ui-g-12 ui-lg-6">
        <h2>{{'loyalty.point_transfer' | translate}}</h2>
      </div>

      <kv-customer-card-search
        (onCardSelect)="onTransferConfirm($event)"
        (onBack)="_onBack()"
      ></kv-customer-card-search>
    </div>
    <p-dialog *ngIf="showTransferDialog && maxPoint != -1"
              header="{{ 'loyalty.transfer_dialog' | translate }}"
              (onHide)="showTransferDialog = false"
              [(visible)]="showTransferDialog"
              [modal]="true"
              [draggable]="false"
              [resizable]="false">
      <kv-point-transfer-dialog
        *ngIf="showTransferDialog && maxPoint != -1"
        [maxPoint]="maxPoint"
        (onConfirm)="onTransferConfirmProceed($event)"
      >

      </kv-point-transfer-dialog>

    </p-dialog>
  


// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/components/point-transfer.component.ts.PointTransferComponent.html